import { NDC_LOGO_FILE, TEIN_ATU_BADGE_FILE } from './idCardTemplate';

function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () =>
      resolve(typeof reader.result === 'string' ? reader.result : null);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

/**
 * Loads `public/` logos as data URLs so ID card PDF/HTML does not rely on separate HTTP
 * requests inside an iframe (avoids CORS/timing issues). Same-origin fetch only.
 *
 * @returns {Promise<{ ndcDataUrl: string, teinDataUrl: string }>}
 */
export async function fetchIdCardPublicAssetsAsDataUrls() {
  const pub = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const ndcPath = pub ? `${pub}/${NDC_LOGO_FILE}` : `/${NDC_LOGO_FILE}`;
  const teinPath = pub ? `${pub}/${TEIN_ATU_BADGE_FILE}` : `/${TEIN_ATU_BADGE_FILE}`;
  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  const fetchOne = async (path) => {
    try {
      const res = await fetch(`${origin}${path}`, { credentials: 'same-origin' });
      if (!res.ok) return null;
      return blobToDataUrl(await res.blob());
    } catch {
      return null;
    }
  };

  const [ndcDataUrl, teinDataUrl] = await Promise.all([
    fetchOne(ndcPath),
    fetchOne(teinPath),
  ]);

  const inline = {};
  if (ndcDataUrl) inline.ndcDataUrl = ndcDataUrl;
  if (teinDataUrl) inline.teinDataUrl = teinDataUrl;
  return inline;
}
